import { render, staticRenderFns } from "./CommonFormWithDeliveryEditor.vue?vue&type=template&id=35afe4d9&lang=pug&"
import script from "./CommonFormWithDeliveryEditor.vue?vue&type=script&lang=ts&"
export * from "./CommonFormWithDeliveryEditor.vue?vue&type=script&lang=ts&"
import style0 from "./CommonFormWithDeliveryEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports